import React from "react";

const TextSection = () => {
  return (
    <div className="custom__container text__section">
      <h3>Website Terms & Conditions</h3>
      <br />
      <p>
        Welcome to the websites of FLEXGRADE, LLC., doing business as FlexGrade,
        together with any of its affiliates, which includes subsidiaries and
        entities that FlexGrade currently operates or may operate in future
        (collectively, “FlexGrade,” “we,” or “us”) where you can find
        information on the products and services we offer. The following terms
        and conditions, together with the FlexGrade Privacy Policy found HERE ,
        (collectively, these “Terms”), govern your access to and use of any
        websites or mobile application as unregistered website user or visitor
        (collectively “user” or “you”) where these Terms are posted, including
        any content, functionality, and services offered on or through those
        websites (collectively, the “Site”, “Sites” or “Mobile Application”).
      </p>
      <br />
      <p>
        Please read these Terms carefully before you access or use the Site.
        When you access or use the Site or Mobile Application, you agree to
        these Terms and represent and warrant that you are 18 years of age or
        older. IF YOU DO NOT AGREE TO THESE TERMS OR DO NOT MEET ALL OF THESE
        REQUIREMENTS, DO NOT ACCESS OR USE THE SITE.
      </p>
      <br />
      <p>
        If you have purchased any of our products and/or services , there are
        additional terms and conditions that govern your use of said services.
        Our additional terms can be found here.
      </p>
      <br />
      <p>
        The Terms apply, regardless of the device used to access the Sites
        (e.g., personal computer, mobile device, consumer electronics device, or
        any other technology or software known today or developed in the
        future). If you use a mobile application or other online service and are
        required to agree to a separate governing agreement, including, without
        limitation, a terms of use, end user license agreement, or privacy
        policy (collectively, “Other Governing Agreement”), in order to use,
        access, and/or download such application or other online service, both
        these Terms and the Other Governing Agreement will govern the use of the
        applicable mobile application or online service, provided that in the
        event of a conflict, the Other Governing Agreement will control.
      </p>
      <h6>Access, Use, and Restrictions</h6>
      <br />
      <p>
        You represent, warrant, and covenant that you will access and use the
        Site only as set forth in these Terms. You will comply with any other
        applicable terms and conditions of use set forth on the Site or Other
        Governing Agreement, if applicable.
      </p>
      <br />
      <p>
        You acquire absolutely no rights or licenses in or to the Site and
        materials contained within the Site other than the limited right for you
        to access and use the Site in accordance with the Terms. You may not
        access or use the Site for any illegal purpose, to facilitate the
        violation of any law or regulation, or in a manner inconsistent with
        these Terms. Your access and use of the Site is solely for your or your
        company’s use and benefit. You may not copy, reproduce, recompile,
        decompile, disassemble, reverse engineer, distribute, publish, display,
        perform, modify, upload to, create derivative works from, transmit, or
        in any way exploit any part of the Site, except as set forth in the
        Terms or as explicitly specified in the Site. You may download material
        from the Site and/or make a reasonable number of copies of the material
        from the Site for your or your company’s use and benefit, provided that
        you reproduce all copyright and other proprietary notices.
      </p>
      <br />
      <p>
        You may not access, monitor, or copy any content or information on the
        Site using any robot, spider, scraper, web crawler, or other automated
        means or any similar manual process. You may not violate the security of
        this Site or attempt to gain unauthorized access to the Site or computer
        systems or networks connected to the Site through any means.
      </p>
      <h6>Changes to the Site and Terms</h6>
      <br />
      <p>
        FlexGrade may discontinue providing the Site or terminate the Terms at
        any time in its sole discretion and may, from time to time, modify the
        Terms. Any modifications to the Terms will be posted on the Site, so
        please check this page periodically. If you do not agree to, or cannot
        comply with, the modified Terms, you must stop using the Site. The
        updated Terms will take effect after its posting and will apply only on
        a going-forward basis, unless otherwise provided in a notice to you.
        Your continued access or use of the Site after any such update
        constitutes your binding acceptance of such changes.
      </p>
      <h6>Accessing the Site and Account Security</h6>
      <br />
      <p>
        To access or use the Site or some of the resources it offers, you may be
        asked to provide certain registration details or other information. It
        is a condition of your access and use of the Site that all the
        information you provide on the Site is correct, current, and complete.
        All information you provide to register with this Site or otherwise,
        including, but not limited to, through the use of any interactive
        features on the Site, is governed by the FlexGrade Privacy Policy, found
        HERE.
      </p>
      <br />
      <p>
        If you choose to register, or are provided with, a username, password,
        or any other piece of information as part of FlexGrade’ security
        procedures, you must treat such information as confidential and not
        disclose it. Your account is personal to you and you will not provide
        any other person with access to this Site or portions of it using your
        user name, password, or other security information. You will notify
        FlexGrade immediately of any unauthorized access to or use of your
        username or password or any other breach of security. You will sign out
        from your account at the end of each session.
      </p>
      <h6>User Content</h6>
      <br />
      <p>
        The Sites may enable you to submit, post, upload, or otherwise make
        available through the Sites (collectively, “post”) content such as video
        clips, photographs, public messages, comments, and other content
        (collectively, “User Content”) that may or may not be viewable by other
        users. Your username may be associated with any User Content that you
        post. You represent and warrant to FlexGrade that you have all required
        rights to any User Content you post on or through the Sites.
      </p>
      <br />
      <p>
        When you post User Content on or through your access or use of any of
        the Sites, you grant FlexGrade a world-wide, perpetual, irrevocable,
        royalty-free, non-exclusive, and sub-licensable license to use, copy,
        distribute, reproduce, modify, edit, adapt, publicly perform, publicly
        display, translate, create derivative works from, publish, and in any
        way exploit such User Content, in whole or in part, in any format or
        medium now known or developed in the future, including, without
        limitation, for promoting and redistributing part or all of the Services
        (and derivative works thereof) in any media formats and through any
        media channels.
      </p>
      <h6>Discussion Forums / Online Communities</h6>
      <br />
      <p>
        Some of the Sites provide online communities or forums to help FlexGrade
        customers, prospective customers, and partners discuss FlexGrade
        products and services. FlexGrade will have no liability for any action
        or inaction by FlexGrade or any third-party content provider with
        respect to any conduct, communication, or posting on the Sites, and
        under no circumstances will FlexGrade be liable for any loss or damage
        of any kind caused by reliance on information obtained through postings
        on the Sites. FlexGrade reserves the right at all times to disclose any
        information it believes necessary to satisfy any law, regulation, or
        governmental request, or to refuse to post or to remove any information
        or materials, in whole or in part, that in FlexGrade’s sole discretion
        are inappropriate, objectionable, or in violation of these Terms or
        Privacy Policy. FlexGrade is a provider of an interactive computing
        service as set forth in the Communications Decency Act, 47 U.S.C. §230
        and expressly reserves its rights to not be treated as the publisher or
        speaker of any information provided by another information content
        provider on the Sites. By using the Site, any forum or online community,
        or providing any other User Content on or through the Sites, you agree
        to follow any usage guidelines set forth on such Site, forum, or online
        community.
      </p>
      <br />
      <h6>Intellectual Property</h6>
      <p>
        The Site is protected by copyrights, trademarks, service marks,
        international treaties, and/or other proprietary rights and laws of the
        United States and other countries. The Site is also protected as a
        collective work or compilation under U.S. copyright and other laws and
        treaties. You will abide by all applicable copyright and other laws, as
        well as any additional copyright notices or restrictions contained in
        the Site. You acknowledge that the Site has been developed by FlexGrade
        and others and constitutes valuable intellectual property of FlexGrade.
        All present and future rights in and to trade secrets, patents,
        copyrights, trademarks, service marks, know-how, and other proprietary
        rights of any type under the laws of any governmental authority,
        domestic or foreign, including rights in and to all applications and
        registrations relating to the Site will, as between you and FlexGrade,
        at all times be and remain the sole and exclusive property of FlexGrade.
        All content is for general informational purposes only. We reserve the
        right, but do not have any obligation to monitor, remove, edit, modify
        or remove any content, in our sole discretion, at any time for any
        reason or for no reason at all.
      </p>
      <br />
      <p>
        You may not use any of FlexGrade’ trademarks without the prior written
        permission of FlexGrade. Use of the Site does not grant any right to any
        content on the Site. Subject to these Website Terms, we grant each user
        of the Site a worldwide, non-exclusive, non-sublicensable and
        non-transferable license to use (i.e., to download and display locally)
        Content solely for viewing, browsing and using the functionality of the
        Site.
      </p>
      <h6>
        NOTICE AND PROCEDURE FOR MAKING CLAIMS OF INTELLECTUAL PROPERTY
        INFRINGEMENT
      </h6>
      <br />
      <p>
        FlexGrade has a policy of, in appropriate circumstances and at its
        discretion, terminating the accounts of users who infringe the
        intellectual property of others, including accounts of repeat
        infringers. If you believe that your work has been copied in a way that
        constitutes copyright infringement, or your intellectual property rights
        have been otherwise violated, please provide FlexGrade’ Copyright Agent
        (as identified below) a notice containing the following information:
      </p>
      <br />
      <ul className="roman__list">
        <li>
          an electronic or physical signature of the person authorized to act on
          behalf of the owner of the copyright or other intellectual property
          interest that has allegedly been infringed;
        </li>
        <li>
          a description of the copyrighted work or other intellectual property
          that you claim has been infringed, or, if multiple copyrighted works
          at a single online location are covered by a single notification, a
          representative list of such works at that location;
        </li>
        <li>
          identification of the material that is claimed to be infringing or to
          be the subject of infringing activity, and a description of where that
          material is located;
        </li>
        <li>your address, telephone number, and email address;</li>
        <li>
          a statement by you that you have a good faith belief that the disputed
          use is not authorized by the copyright owner, its agent, or the law;
          and
        </li>
        <li>
          a statement by you that the above information in your notice is
          accurate and, under penalty of perjury, that you are the copyright or
          intellectual property owner or authorized to act on the copyright or
          intellectual property owner’s behalf.
        </li>
      </ul>
      <h6>Disclaimer of Warranties / Limitation on Liability</h6>
      <br />
      <p>
        YOUR ACCESS OR USE OF THE SITE IS AT YOUR SOLE RISK AND ALL INFORMATION
        CONTAINED ON THE SITE IS PROVIDED “AS IS” AND “AS AVAILABLE.” FLEXGRADE
        AND ITS OFFICERS, DIRECTORS, PARTNERS, REPRESENTATIVES, EMPLOYEES, AND
        AGENTS (COLLECTIVELY, “FlexGrade” IN THIS SECTION) MAKE NO WARRANTY OF
        ANY KIND, EXPRESS OR IMPLIED, AS TO THE SITE, INCLUDING, BUT NOT LIMITED
        TO, WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, TITLE, OR FITNESS
        FOR A PARTICULAR PURPOSE OR USE.
      </p>
      <br />
      <p>
        TO THE EXTENT PERMITTED BY LAW, WE AND OUR AFFILIATES, PARENTS, AND
        SUCCESSORS AND EACH OF OUR AND THEIR EMPLOYEES, ASSIGNEES, OFFICERS,
        AGENTS AND DIRECTORS (COLLECTIVELY, THE “FLEXGRADE PARTIES”) DISCLAIM
        ALL WARRANTIES AND TERMS, EXPRESS OR IMPLIED, WITH RESPECT TO THE SITE,
        CONTENT OR SERVICES (INCLUDING THIRD-PARTY SERVICES) ON OR ACCESSIBLE
        THROUGH THE SITE, INCLUDING ANY WARRANTIES OR TERMS OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT AND ANY
        IMPLIED WARRANTIES, OR ARISING FROM COURSE OF DEALING, COURSE OF
        PERFORMANCE OR USAGE IN TRADE. IN NO EVENT SHALL THE FLEXGRADE PARTIES
        BE LIABLE UNDER CONTRACT, TORT, STRICT LIABILITY, NEGLIGENCE OR ANY
        OTHER LEGAL OR EQUITABLE THEORY WITH RESPECT TO THE SITE FOR (A) ANY
        SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, COMPENSATORY OR CONSEQUENTIAL
        DAMAGES OF ANY KIND WHATSOEVER (HOWEVER ARISING) OR (B) DAMAGES IN
        EXCESS OF (IN THE AGGREGATE) US$100.
      </p>
      <br />
      <p>
        The content of other websites, services, goods, or advertisements that
        may be linked to or from the Site is not maintained or controlled by
        FlexGrade. FlexGrade is therefore not responsible for the availability,
        content, or accuracy of other websites, services, goods, or
        advertisements that may be linked to or from the Site.
      </p>
      <h6>Governing Law</h6>
      <br />
      <p>
        The Terms will be governed and construed in accordance with the laws of
        the State of Delaware, without giving effect to conflicts-of-law
        principles thereof. For any dispute relating to FlexGrade’s provision of
        and your access to or use of the Sites, you and FlexGrade will submit to
        the personal and exclusive jurisdiction of and venue in the federal and
        state courts located in New Castle County in the State of Delaware. You
        further will accept service of process by mail, and hereby waive any and
        all jurisdictional and venue defenses otherwise available.
      </p>
      <h6>General</h6>
      <br />
      <p>
        These Terms (including FlexGrade’s Privacy Policy and other terms
        incorporated by reference) constitute the entire agreement between you
        and FlexGrade governing your access to and use of the Site. The failure
        or delay of FlexGrade to exercise or enforce any right or provision of
        the Terms will not constitute a waiver of such right or provision. If
        any provision of the Terms is found invalid or unenforceable, that
        provision will be enforced to the maximum extent permissible, and the
        other provisions of the Terms will remain in force. The obligations
        contained in the Terms that by their sense and context are intended to
        survive the performance of the Terms by either or both parties will
        survive the termination, cancellation, expiration, or completion of the
        performance of the Terms.
      </p>
      <h6>Contact.</h6>
      <br />
      <p>
        If you have any questions, complaints, or claims with respect to the
        Site, you may contact us at ATTN: Website Feedback, c/o FlexGrade,{" "}
        <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a>.
      </p>
    </div>
  );
};

export default TextSection;
